import { Component, OnInit } from '@angular/core';
import { NgxSmartModalComponent, NgxSmartModalService } from '@bssh/comp-lib';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { IModalInput, IModalOutput } from '../model/action-modal';

export interface ValidationWarningItem {
  fieldLabel?: string;
  message: string;
}

export interface IValidationWarningsModalInput extends IModalInput {
  title?: string;
  subTitle?: string;
  warnings: ValidationWarningItem[];
  confirmButtonText?: string;
  closeButtonText?: string;
}

export interface IValidationWarningsModalOutput extends IModalOutput {
  isProceed: boolean;
}

@Component({
  selector: 'app-validation-warnings-modal',
  templateUrl: './validation-warnings-modal.component.html',
  styleUrls: ['./validation-warnings-modal.component.scss']
})
export class ValidationWarningsModalComponent extends BaseModalComponent implements OnInit {
  modalType = 'validationWarningsModal';
  title = 'Validation Warnings';
  subTitle = '';
  warnings: ValidationWarningItem[] = [];
  confirmText = 'Yes, proceed';
  closeText = 'No, stay on this page';
  isProceed = false;

  constructor(
    public ngxSmartModalService: NgxSmartModalService
  ) {
    super(ngxSmartModalService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.subs.sink = this.data.subscribe((modalInput: IValidationWarningsModalInput) => {
      if (modalInput) {
        this.title = modalInput.title || this.title;
        this.subTitle = modalInput.subTitle || this.subTitle;
        this.warnings = modalInput.warnings || [];
        this.confirmText = modalInput.confirmButtonText || this.confirmText;
        this.closeText = modalInput.closeButtonText || this.closeText;
      }
    });
  }

  close(modal: NgxSmartModalComponent): void {
    const output: IValidationWarningsModalOutput = { isProceed: this.isProceed };
    this.confirm.emit(output);
    this.confirm.complete();
    super.close(modal);
  }

  accept(modal: NgxSmartModalComponent) {
    this.isProceed = true;
    modal.close();
  }
}
